// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactManager_container__DY9Ba","form":"ContactManager_form__IyzRy"};